import * as React from 'react'
import { SliderClasses } from './sliderClasses'
import clsx from 'clsx'

export interface SliderValueLabelProps {
  children?: React.ReactElement
  className?: string
  classes?: Partial<SliderClasses>
  style?: React.CSSProperties
  /**
   * If `true`, the value label is visible.
   */
  open: boolean
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: number
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay?: 'on' | 'auto' | 'off'
}

const useValueLabelClasses = (props: SliderValueLabelProps) => {
  const { open, classes } = props

  const utilityClasses = {
    offset: open ? classes?.valueLabelOpen : '',
    circle: classes?.valueLabelCircle,
    label: classes?.valueLabelLabel,
  }
  return utilityClasses
}

export function SliderValueLabel(props: SliderValueLabelProps) {
  const { children, className, value } = props
  const classes = useValueLabelClasses(props)

  if (!children) {
    return null
  }

  return React.cloneElement(
    children,
    {
      className: clsx(children.props.className),
    },
    <React.Fragment>
      {children.props.children}
      <span className={clsx(classes.offset, className)} aria-hidden>
        <span className={classes.circle}>
          <span className={classes.label}>{value}</span>
        </span>
      </span>
    </React.Fragment>
  )
}
